/**
 * 2FA 登录视图（任务 6e；protocol §3.3 两阶段）：登录第一阶段返回 Need2FA 后进入，
 * 原登录参数 + 6 位 TOTP 码整体重提。成功不导航——守卫看到 logged-in 自动跳回。
 * 作为 LoginPage 卡片内的子视图（非独立路由：刷新回登录表单重来，可接受）。
 */
import { useState } from 'preact/hooks';
import styles from './login.module.scss';
import { appWorker } from '~/store/appWorker';
import { globalStore } from '~/store/global';
import { loginWith2fa, type LoginCommit, type PendingLogin } from '~/store/authActions';

export function TwoFactorView(props: {
  pending: PendingLogin;
  onBack: () => void;
  /** 添加账号模式透传（14.34b-2）：成功走切换收尾而非直写 auth */
  commit?: LoginCommit | undefined;
}) {
  const [code, setCode] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const ready = /^\d{6}$/.test(code);

  async function submit(event: Event) {
    event.preventDefault();
    if (busy || !ready) return;
    setBusy(true);
    setError('');
    const outcome = await loginWith2fa(appWorker(), globalStore(), props.pending, code, props.commit);
    setBusy(false);
    if (outcome.kind === 'error') setError(outcome.message);
  }

  return (
    <form className={styles.form} data-testid="twofa-view" onSubmit={submit}>
      <h2 className={styles.viewTitle}>两步验证</h2>
      <p className={styles.hint}>请打开身份验证器 App，输入 6 位动态码</p>
      <input
        className={styles.input}
        data-testid="twofa-code"
        placeholder="6 位动态码"
        autocomplete="one-time-code"
        inputMode="numeric"
        maxLength={6}
        value={code}
        onInput={(e) => setCode(e.currentTarget.value.replace(/\D/g, ''))}
      />
      {error !== '' && (
        <p className={styles.error} data-testid="twofa-error">
          {error}
        </p>
      )}
      <button
        className={styles.submit}
        data-testid="twofa-submit"
        type="submit"
        disabled={busy || !ready}
      >
        {busy ? '验证中…' : '验证并登录'}
      </button>
      <button type="button" className={styles.linkButton} data-testid="twofa-back" onClick={props.onBack}>
        返回登录
      </button>
    </form>
  );
}
